import apiSlice from "./ApiSlice";

const BookApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllBookData: builder.query({
      providesTags: ["book"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/book",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteBookById: builder.mutation({
      invalidatesTags: ["book"],
      query: (id: any) => ({
        url: `/book/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addBook: builder.mutation({
      invalidatesTags: ["book"],
      query: (body) => ({
        url: `/book/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getBookById: builder.query({
      providesTags: ["book"],
      query: (id: string) => {
        return {
          url: `/book/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllBook: builder.query({
      providesTags: ["book"],
      query: () => {
        return {
          url: `/book`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateBookById: builder.mutation({
      invalidatesTags: ["book"],
      query: ({ body, id }) => ({
        url: `/book/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusBookById: builder.mutation({
      invalidatesTags: ["book"],
      query: ({ body, id }) => ({
        url: `/book/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllBookDataQuery,
  useDeleteBookByIdMutation,
  useAddBookMutation,
  useGetBookByIdQuery,
  useUpdateBookByIdMutation,
  useGetAllBookQuery,
  useChangeStatusBookByIdMutation,
} = BookApi;
